import BaseModel from './BaseModel';

/** Class representing a student enrolment. */
class StudentEnrolment extends BaseModel {
    static STATUS_NONE    = 'none';
    static STATUS_OK      = 'ok';
    static STATUS_PENDING = 'pending';
    static STATUS_REFUSED = 'refused';

    static status() {
        return [
            this.STATUS_NONE,
            this.STATUS_PENDING,
            this.STATUS_OK,
            this.STATUS_REFUSED
        ];
    }
}

export default StudentEnrolment;
